import { AccountStatus, type UserProfile } from '$shared/types/api';

/** Account type GUIDs — must match Stathub.Api InitialDatasets / mobile_app AccountType. */
export const ACCOUNT_TYPE = {
  healthcareProfessional: '8b292ec1-b5cb-4a09-8a63-2e711dad976b',
  industryProfessional: '936959ee-af17-40ec-974a-dd509269c776',
  generalPublic: 'd420f7ce-d142-41c2-995e-282f979d7bf9',
} as const;

export type AccountTypeId = (typeof ACCOUNT_TYPE)[keyof typeof ACCOUNT_TYPE];

/** Account types offered on public web signup (General User hidden for now). */
export const PUBLIC_ONBOARDING_ACCOUNT_TYPES: AccountTypeId[] = [
  ACCOUNT_TYPE.healthcareProfessional,
  ACCOUNT_TYPE.industryProfessional,
];

function normalizeAccountTypeId(accountType: string | undefined | null): string {
  return accountType?.toLowerCase() ?? '';
}

export function isHealthcareProfessional(profile: Pick<UserProfile, 'accountType'>): boolean {
  return normalizeAccountTypeId(profile.accountType) === ACCOUNT_TYPE.healthcareProfessional;
}

export function isIndustryProfessional(profile: Pick<UserProfile, 'accountType'>): boolean {
  return normalizeAccountTypeId(profile.accountType) === ACCOUNT_TYPE.industryProfessional;
}

export function isGeneralPublic(profile: Pick<UserProfile, 'accountType'>): boolean {
  return normalizeAccountTypeId(profile.accountType) === ACCOUNT_TYPE.generalPublic;
}

/** CLARA is only available to healthcare professionals. */
export function canAccessClara(profile: Pick<UserProfile, 'accountType'>): boolean {
  return isHealthcareProfessional(profile);
}

export function getAccountTypeLabel(accountType: string | undefined | null): string {
  switch (normalizeAccountTypeId(accountType)) {
    case ACCOUNT_TYPE.healthcareProfessional:
      return 'Healthcare Professional';
    case ACCOUNT_TYPE.industryProfessional:
      return 'Industry Professional';
    case ACCOUNT_TYPE.generalPublic:
      return 'General User';
    default:
      return 'Not Provided';
  }
}

export function formatAccountStatus(status: AccountStatus | string | undefined | null): string {
  if (!status) return AccountStatus.Active;
  return String(status);
}
